"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.symbolProp = void 0;

var util_1 = require("../util");

var validators_1 = require("../validators");
/**
 * Allows any symbol (validated at runtime and compile time).
 *
 * @param validator - Optional function for further runtime validation; should return `undefined` if valid, or an error string if invalid.
 */


var symbolProp = function symbolProp(validator) {
  return (0, util_1.propOptionsGenerator)(undefined, validator, validators_1.isSymbol);
};

exports.symbolProp = symbolProp;